/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 */

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) =>
  key in obj
    ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value,
      })
    : (obj[key] = value);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// node_modules/ftdomdelegate/main.js
function Delegate(root) {
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }
  this.handle = Delegate.prototype.handle.bind(this);
  this._removedListeners = [];
}
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }
  this.rootElement = root;
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }
  return this;
};
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;
  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }
  if (useCapture === void 0) {
    useCapture = this.captureForType(eventType);
  }
  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }
  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }
  if (!selector) {
    matcherParam = null;
    matcher = matchesRoot.bind(this);
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }
  listenerMap[eventType].push({
    selector,
    handler,
    matcher,
    matcherParam,
  });
  return this;
};
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }
  if (useCapture === void 0) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }
    return this;
  }
  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];
    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }
  if (!listenerList.length) {
    delete listenerMap[eventType];
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }
  return this;
};
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";
  if (event[eventIgnore] === true) {
    return;
  }
  target = event.target;
  if (target.nodeType === 3) {
    target = target.parentNode;
  }
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }
  root = this.rootElement;
  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
  switch (phase) {
    case 1:
      listenerList = this.listenerMap[1][type];
      break;
    case 2:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3:
      listenerList = this.listenerMap[0][type];
      break;
  }
  let toFire = [];
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];
      if (!listener) {
        break;
      }
      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        toFire = [];
      } else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }
    if (target === root) {
      break;
    }
    l = listenerList.length;
    target = target.parentElement || target.parentNode;
    if (target instanceof HTMLDocument) {
      break;
    }
  }
  let ret;
  for (i = 0; i < toFire.length; i++) {
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }
  return ret;
};
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      element === document ||
      element === document.documentElement ||
      element === window
    );
  }
  return this.rootElement === element;
}
function matchesId(id, element) {
  return id === element.id;
}
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};
var main_default = Delegate;

// js/custom-element/custom-html-element.js
var CustomHTMLElement = class extends HTMLElement {
  constructor() {
    super();
    this._hasSectionReloaded = false;
    if (Shopify.designMode) {
      this.rootDelegate.on("shopify:section:select", (event) => {
        const parentSection = this.closest(".shopify-section");
        if (event.target === parentSection && event.detail.load) {
          this._hasSectionReloaded = true;
        }
      });
    }
  }
  get rootDelegate() {
    return (this._rootDelegate =
      this._rootDelegate || new main_default(document.documentElement));
  }
  get delegate() {
    return (this._delegate = this._delegate || new main_default(this));
  }
  showLoadingBar() {
    triggerEvent(document.documentElement, "theme:loading:start");
  }
  hideLoadingBar() {
    triggerEvent(document.documentElement, "theme:loading:end");
  }
  untilVisible(
    intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }
  ) {
    const onBecameVisible = () => {
      this.classList.add("became-visible");
      this.style.opacity = "1";
    };
    return new Promise((resolve) => {
      if (window.IntersectionObserver) {
        this.intersectionObserver = new IntersectionObserver((event) => {
          if (event[0].isIntersecting) {
            this.intersectionObserver.disconnect();
            requestAnimationFrame(() => {
              resolve();
              onBecameVisible();
            });
          }
        }, intersectionObserverOptions);
        this.intersectionObserver.observe(this);
      } else {
        resolve();
        onBecameVisible();
      }
    });
  }
  disconnectedCallback() {
    var _a;
    this.delegate.destroy();
    this.rootDelegate.destroy();
    (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
    delete this._delegate;
    delete this._rootDelegate;
  }
};

/*****************************************
/ Store pickup
/*****************************************/
// ~DIG-91 replacing theme.js element
var StorePickup = class extends HTMLElement {
  connectedCallback() {
    var _a;
    (_a = document.getElementById(this.getAttribute("form-id"))) == null
      ? void 0
      : _a.addEventListener(
          "variant:changed",
          this._onVariantChanged.bind(this)
        );
  }
  _onVariantChanged(event) {
    var variant = event.detail.variant;
    var $abholinfo = this.querySelector(
      ".product-form__variation-infos__abholinfo"
    );
    if (
      !variant ||
      !variant.id ||
      !all_variants ||
      !all_variants[variant.id] ||
      !all_variants[variant.id].metafields ||
      !all_variants[variant.id].metafields.abholinfo
    ) {
      this.classList.add("hidden");
    } else {
      const abholinfo = all_variants[variant.id].metafields.abholinfo;
      this.classList.remove("hidden");
      $abholinfo.innerHTML = abholinfo;
    }
  }
};
window.customElements.define("store-pickup", StorePickup);

/*****************************************
/ Variation infos lieferzeit
/*****************************************/
// TODO: REBUILD AS CUSTOM ELEMENT
document.addEventListener("variant:changed", function (event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  setVariantInfos(variant);
});

function setVariantInfos(variant) {
  var $lieferzeitDD = document.querySelector(
    "dd.product-form__variation-infos__lieferzeit"
  );
  var $lieferzeitDT = document.querySelector(
    "dt.product-form__variation-infos__lieferzeit"
  );
  var $variationInfos = document.querySelector(
    ".product-form__variation-infos"
  );
  if (!$lieferzeitDD) return;

  if (
    typeof all_variants === "object" &&
    typeof all_variants[variant.id] !== undefined
  ) {
    var variantInfos = all_variants[variant.id];

    if (variantInfos && variantInfos.metafields) {
      $variationInfos.classList.remove("hidden");
      if (variantInfos.metafields.lieferzeit) {
        var lieferzeit = variantInfos.metafields.lieferzeit;

        $lieferzeitDD.innerHTML = lieferzeit;
        $lieferzeitDD.classList.remove("hidden");
        $lieferzeitDT.classList.remove("hidden");
      } else {
        $lieferzeitDD.classList.add("hidden");
        $lieferzeitDT.classList.add("hidden");
      }
    } else {
      $lieferzeitDD.classList.add("hidden");
      $lieferzeitDT.classList.add("hidden");
    }
  } else {
    $variationInfos.classList.add("hidden");
  }
}

/*****************************************
/ Variation additional infos
/*****************************************/

var VariantAdditionalInfo = class extends HTMLElement {
  connectedCallback() {
    var _a;
    (_a = document.getElementById(this.getAttribute("form-id"))) == null
      ? void 0
      : _a.addEventListener(
          "variant:changed",
          this._onVariantChanged.bind(this)
        );
  }
  _onVariantChanged(event) {
    var variant = event.detail.variant;
    // console.log({ variant });
    if (!event.detail.variant) {
      this.innerHTML = "";
    } else {
      this._renderForVariant(variant.id);
    }
  }
  async _renderForVariant(id) {
    const response = await fetch(
      `${window.themeVariables.routes.rootUrlWithoutSlash}/variants/${id}?section_id=variant-details`
    );
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    const variantInfo = div.querySelector(
      `[data-attribut="${this.getAttribute("data-option")}"]`
    );
    if (variantInfo) {
      this.innerHTML = variantInfo.innerHTML.trim();
    } else {
      this.innerHTML = "";
    }
  }
};
window.customElements.define("variant-additional-info", VariantAdditionalInfo);

/*****************************************
/ Variation base prices
/*****************************************/

var VariationBasePrices = class extends HTMLElement {
  connectedCallback() {
    // console.log("VariationBasePrices");
    var _a;
    (_a = document.getElementById(this.getAttribute("form-id"))) == null
      ? void 0
      : _a.addEventListener(
          "variant:changed",
          this._onVariantChanged.bind(this)
        );
  }
  _onVariantChanged(event) {
    var variant = event.detail.variant;
    // console.log({ variant });
    if (!event.detail.variant) {
      this.innerHTML = "";
    } else {
      this._renderForVariant(variant.id);
    }
  }
  async _renderForVariant(id) {
    const response = await fetch(
      `${window.themeVariables.routes.rootUrlWithoutSlash}/variants/${id}?section_id=price-list`
    );
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    const content = div.querySelector(`variation-base-prices`);
    if (content) {
      this.innerHTML = content.innerHTML.trim();
    } else {
      this.innerHTML = "";
    }
  }
};
window.customElements.define("variation-base-prices", VariationBasePrices);

var QtyBasePrices = class extends HTMLElement {
  connectedCallback() {
    // console.log("QtyBasePrices");
    var _a, _b, _c;
    (_a = document.getElementById(this.getAttribute("form-id"))) == null
      ? void 0
      : _a.addEventListener(
          "variant:changed",
          this._onVariantChanged.bind(this)
        );
    (_b = document.querySelector(".product-form .quantity-selector__input")) ==
    null
      ? void 0
      : _b.addEventListener("input", this._handleChangeQty.bind(this));
    (_c = document.querySelectorAll(".quantity-selector__button")).length < 1
      ? void 0
      : _c.forEach((button, index) => {
          button.addEventListener("touchend", this._handleChangeQty.bind(this));
          button.addEventListener("mouseup", this._handleChangeQty.bind(this));
        });

    // console.log({ _a, _b });
  }
  _onVariantChanged(event) {
    var variant = event.detail.variant;
    if (!event.detail.variant) {
      this.innerHTML = "";
    } else {
      this._renderForVariant(variant.id);
    }
  }
  async _renderForVariant(id) {
    const response = await fetch(
      `${window.themeVariables.routes.rootUrlWithoutSlash}/variants/${id}?section_id=price-base-qty`
    );
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    const content = div.querySelector(`qty-base-prices`);
    if (content) {
      this.innerHTML = content.innerHTML.trim();
      this._handleChangeQty(null);
    } else {
      this.innerHTML = "";
    }
  }
  _handleChangeQty(e) {
    let input;
    if (typeof e === "InputEvent") {
      input = e.target;
    } else {
      input = document.querySelector(".product-form .quantity-selector__input");
    }
    setTimeout(() => {
      const value = input.value;
      if (value) {
        const qty = this.querySelector(".product-form .qty");
        const amount = this.querySelector(".product-form .amount");
        const amountVal = parseFloat(amount.getAttribute("data-value"));
        const total = this.querySelector(".product-form .total");
        const price = parseFloat(total.getAttribute("data-price"));

        if (qty) qty.innerHTML = value;
        if (amount)
          amount.innerHTML = formatWithDelimiters(
            Math.round(value * amountVal * 100),
            2,
            ".",
            ","
          );
        if (total) total.innerHTML = formatMoney(value * price);
      }
    }, 10);
  }
};
window.customElements.define("qty-base-prices", QtyBasePrices);

/*****************************************
/ Variation required product
/*****************************************/
// ~DIG-77
var RequiredProduct = class extends HTMLElement {
  async connectedCallback() {
    var _a;
    this.fallbackDiv = document.createElement("div");

    const product = JSON.parse(
      document.getElementById("productJson").innerHTML
    );
    if (product.handle) {
      const response = await fetch(
        `${window.themeVariables.routes.rootUrlWithoutSlash}/products/${product.handle}?section_id=required-product`
      );
      this.fallbackDiv.innerHTML = await response.text();
    }

    (_a = document.getElementById(this.getAttribute("form-id"))) == null
      ? void 0
      : _a.addEventListener(
          "variant:changed",
          this._onVariantChanged.bind(this)
        );
  }
  _onVariantChanged(event) {
    if (!event.detail.variant) {
      this.innerHTML = "";
    } else {
      this._renderForVariant(event.detail.variant["id"]);
    }
  }
  async _renderForVariant(id) {
    const response = await fetch(
        `${window.themeVariables.routes.rootUrlWithoutSlash}/variants/${id}?section_id=required-product`
      ),
      div = document.createElement("div");
    div.innerHTML = await response.text();
    if (div.querySelector("required-product").innerHTML.trim() != "") {
      this.innerHTML = div.querySelector("required-product").innerHTML.trim();
    } else {
      this.innerHTML = this.fallbackDiv
        .querySelector("required-product")
        .innerHTML.trim();
    }
  }
};
window.customElements.define("required-product", RequiredProduct);

/*
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 */

// js/custom-element/section/cart/notification.js
var CartNotification = class extends CustomHTMLElement {
  connectedCallback() {
    this.rootDelegate.on(
      "cart-notification:show",
      this._onShow.bind(this),
      !this.hasAttribute("global")
    );
    this.delegate.on("click", '[data-action="close"]', (event) => {
      event.stopPropagation();
      this.hidden = true;
    });
    // START ~DIG-77
    document.addEventListener("click", (event) => {
      const specifiedElement =
        document.getElementsByClassName("cart-notification")[0];
      const isClickInside = specifiedElement.contains(event.target);
      if (!isClickInside) {
        this.hidden = true;
      }
    });
    this.addEventListener("mouseenter", this.stopTimer.bind(this));
    this.addEventListener("mouseleave", this.startTimer.bind(this));
    window.addEventListener("pagehide", () => (this.hidden = true));
  }
  // END ~DIG-77
  set hidden(value) {
    if (!value) {
      this.startTimer();
    } else {
      this.stopTimer();
    }
    this.toggleAttribute("hidden", value);
  }
  get isInsideDrawer() {
    return this.classList.contains("cart-notification--drawer");
  }
  stopTimer() {
    clearTimeout(this._timeout);
  }
  startTimer() {
    // COMMENTED OUT ~DIG-77
    // this._timeout = setTimeout(() => this.hidden = true, 3e3);
  }
  _onShow(event) {
    if (this.isInsideDrawer && !this.closest(".drawer").open) {
      return;
    }
    if (
      this.hasAttribute("global") &&
      event.detail.status === "success" &&
      window.themeVariables.settings.cartType === "drawer"
    ) {
      return;
    }
    event.stopPropagation();
    let closeButtonHtml = "";
    if (!this.isInsideDrawer) {
      closeButtonHtml = `
        <button class="cart-notification__close tap-area" data-action="close">
          <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>
          <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
            <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
          </svg>
        </button>
      `;
    }
    if (event.detail.status === "success") {
      this.classList.remove("cart-notification--error");
      const required_product = document
        .querySelector("required-product")
        .innerHTML.trim();
      this.innerHTML = `
        <div class="cart-notification__overflow">
          <div class="container">
            <div class="cart-notification__wrapper">
              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                <path d="M6 10L9 13L14 7" fill="none" stroke="rgb(var(--success-color))" stroke-width="2"></path>
              </svg>
              
              <div>
                <div class="cart-notification__text-wrapper">
                  <span class="cart-notification__heading heading hidden-phone">${window.themeVariables.strings.cartItemAdded}</span>
                  <span class="cart-notification__heading heading hidden-tablet-and-up">${window.themeVariables.strings.cartItemAddedShort}</span>
                  <a href="${window.themeVariables.routes.cartUrl}" class="cart-notification__view-cart link">${window.themeVariables.strings.cartViewCart}</a>
                </div>
                <div class="cart-notification__required-product-wrapper">
                ${required_product}
                </div>
              </div>
              
              ${closeButtonHtml}
            </div>
          </div>
        </div>
      `;
    } else {
      this.classList.add("cart-notification--error");
      this.innerHTML = `
        <div class="cart-notification__overflow">
          <div class="container">
            <div class="cart-notification__wrapper">
              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>
              </svg>
              
              <div class="cart-notification__text-wrapper">
                <span class="cart-notification__heading heading">${event.detail.error}</span>
              </div>
              
              ${closeButtonHtml}
            </div>
          </div>
        </div>
      `;
    }
    this.clientHeight;
    this.hidden = false;
  }
};
window.customElements.define("cart-notification", CartNotification);

/* ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/*****************************************
/ Scrollers
/*****************************************/
// TODO: REBUILD AS CUSTOM ELEMENT?
document.addEventListener("DOMContentLoaded", initializeCustom, false);
function initializeCustom() {
  scrollersInitialize();

  var $scrollers = document.querySelectorAll(".scroller > .hide-scrollbar");
  $scrollers.forEach(function ($scroller, key) {
    setInterval(() => {
      scrollerButtonsCheckEnabled($scroller);
    }, 300);
  });

  var resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      scrollersInitialize();
    }, 1000);
  });
}

function scrollersInitialize() {
  var $scrollers = document.querySelectorAll(".scroller > .hide-scrollbar");
  $scrollers.forEach(function ($scroller, key) {
    scrollerButtonsInitialize($scroller);
  });
}

function scrollerButtonsInitialize($scroller) {
  //clean up
  var $scrollerButtons =
    $scroller.parentNode.querySelector(".scroller__buttons");
  if ($scrollerButtons) {
    $scrollerButtons.parentNode.removeChild($scrollerButtons);
  }

  if ($scroller.clientWidth >= $scroller.scrollWidth) return;

  var $scrollerWrap = $scroller.parentNode;

  //create buttons
  $scrollerButtons = document.createElement("div");
  $scrollerButtons.classList.add("scroller__buttons");

  $scrollerButtonNext = document.createElement("button");
  $scrollerButtonNext.classList.add("scroller__button");
  $scrollerButtonNext.classList.add("scroller__button-next");
  $scrollerButtonNext.innerHTML = "next";
  $scrollerButtonNext.addEventListener("click", () => {
    $scroller.dispatchEvent(scrollNext);
  });

  let scrollNext = new CustomEvent("scroll-next", {
    bubbles: true,
    cancelable: true,
  });

  $scrollerButtonPrev = document.createElement("button");
  $scrollerButtonPrev.classList.add("scroller__button");
  $scrollerButtonPrev.classList.add("scroller__button-prev");
  $scrollerButtonPrev.innerHTML = "prev";
  $scrollerButtonPrev.addEventListener("click", () => {
    $scroller.dispatchEvent(scrollPrev);
  });

  let scrollPrev = new CustomEvent("scroll-prev", {
    bubbles: true,
    cancelable: true,
  });

  $scrollerButtons.appendChild($scrollerButtonPrev);
  $scrollerButtons.appendChild($scrollerButtonNext);
  $scrollerWrap.appendChild($scrollerButtons);

  $scroller.addEventListener("scroll-next", function (event) {
    event.target.scrollBy(10, 0);
  });
  $scroller.addEventListener("scroll-prev", function (event) {
    event.target.scrollBy(-10, 0);
  });
  // $scroller.addEventListener("scrollend", function (event) {
  //   var $scroller = event.target.scroll;
  //   scrollerButtonsCheckEnabled($scroller);
  // });
}

function scrollerButtonsCheckEnabled($scroller) {
  var $scrollerWrap = $scroller.parentNode;
  var $scrollerButtonPrev = $scrollerWrap.querySelector(
    ".scroller__button-prev"
  );
  if ($scrollerButtonPrev) {
    if ($scroller.scrollLeft === 0) {
      $scrollerButtonPrev.setAttribute("disabled", true);
    } else {
      $scrollerButtonPrev.removeAttribute("disabled");
    }
  }

  var $scrollerButtonNext = $scrollerWrap.querySelector(
    ".scroller__button-next"
  );
  if ($scrollerButtonNext) {
    if ($scroller.scrollLeft >= $scroller.scrollWidth - $scroller.clientWidth) {
      $scrollerButtonNext.setAttribute("disabled", true);
    } else {
      $scrollerButtonNext.removeAttribute("disabled");
    }
  }
}

/*****************************************
/ gclid typeform
/*****************************************/
document.addEventListener("DOMContentLoaded", setTypeformGclid, false);
function setTypeformGclid() {
  var gclidCookie = getCookie("_shopify_sa_p");
  try {
    var gclid = getParameterByName("gclid");
    if (!gclid) {
      gclid = decodeURIComponent(gclidCookie).split("=")[1];
    }
    if (gclid) {
      var typeformLinks = document.querySelectorAll(
        'a[href^="https://montario.typeform.com"]'
      );
      typeformLinks.forEach((a, i) => {
        var href = a.getAttribute("href");
        var url = new URL(href);
        url.searchParams.set("gclid", gclid);
        a.setAttribute("href", url.href);
      });
    }
  } catch (error) {
    console.error({ error });
  }
}

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// js/custom-element/section/cart/cart-drawer-recommendations.js
var CartDrawerRecommendations = class extends HTMLElement {
  async connectedCallback() {
    const response = await fetch(`/?section_id=${this.sectionId}`);
    const div = document.createElement("div");
    div.innerHTML = await response.clone().text();
    const productRecommendationsElement = div.querySelector(
      "cart-drawer-recommendations"
    );
    if (
      productRecommendationsElement &&
      productRecommendationsElement.hasChildNodes()
    ) {
      this.innerHTML = productRecommendationsElement.innerHTML;
    } else {
      this.hidden = true;
    }
  }
  get productId() {
    return this.getAttribute("product-id");
  }
  get sectionId() {
    return this.getAttribute("section-id");
  }
};
window.customElements.define(
  "cart-drawer-recommendations",
  CartDrawerRecommendations
);

function formatWithDelimiters(number, precision, thousands, decimal) {
  precision = defaultTo(precision, 2);
  thousands = defaultTo(thousands, ",");
  decimal = defaultTo(decimal, ".");
  if (isNaN(number) || number == null) {
    return 0;
  }
  number = (number / 100).toFixed(precision);
  let parts = number.split("."),
    dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    ),
    centsAmount = parts[1] ? decimal + parts[1] : "";
  return dollarsAmount + centsAmount;
}

function defaultTo(value2, defaultValue) {
  return value2 == null || value2 !== value2 ? defaultValue : value2;
}

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
